import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { EmbedProvider } from './context/EmbedContext';
import { ReservationLayout } from './pages/ReservationLayout';
import { DatePeopleSelection } from './pages/DatePeopleSelection';
import { TimeslotSelection } from './pages/TimeslotSelection';
import { SeatingOptions } from './pages/SeatingOptions';
import { ConfirmationScreen } from './pages/ConfirmationScreen';
import { ThankYouScreen } from './pages/ThankYouScreen';
import { ReservationStatus } from './pages/ReservationStatus';
import { ReservationManagement } from './pages/ReservationManagement';
import { CookieConsent } from './components/CookieConsent';
import { AnalyticsPageViews } from './components/AnalyticsPageViews';

const isDev = import.meta.env.VITE_NODE_ENV === 'DEV';
const reservePath = isDev ? '/reserve/:domain' : '/reserve';

function App() {
  return (
    <EmbedProvider>
      <BrowserRouter>
        <AnalyticsPageViews />
        <Routes>
          <Route path={reservePath} element={<ReservationLayout />}>
            <Route index element={<DatePeopleSelection />} />
            <Route path="timeslots" element={<TimeslotSelection />} />
            <Route path="seating" element={<SeatingOptions />} />
            <Route path="submit" element={<ConfirmationScreen />} />
            <Route path="success" element={<ThankYouScreen />} />
            <Route path="status/:reservationId" element={<ReservationStatus />} />
            <Route path="manage/:reservationUuid" element={<ReservationManagement />} />
          </Route>
          <Route path="*" element={<Navigate to="/reserve" replace />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </EmbedProvider>
  );
}

export default App;
